import React from 'react';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/styles";
import Divider from "@material-ui/core/Divider";
import { useTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    card: {
        height: '100%',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius: 0,
        backgroundColor: '#FFF'
    },
    cardSelected: {
        backgroundColor: `transparent`
    },
    cardHeaderRoot: {
        padding: theme.spacing(2, 1)
    },
    cardHeaderTitle: {
        fontSize: '0.875rem',
        // minHeight: 40
        // fontWeight: theme.typography.fontWeightMedium
    },
    cardContent: {
        padding: 0
    },
    listRoot: {
        padding: 0
    },
    primary: {
        // minHeight: 40
    }
}))

const ObjectCard = ({ obiekt, selected }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div style={{height:'100%'}}>
            <Card variant="outlined" className={clsx(classes.card, selected && classes.cardSelected)}>
                <CardHeader
                    classes={{ root: classes.cardHeaderRoot, title: classes.cardHeaderTitle }}
                    title={<><b>{t('obiekt.nazwa_obiektu')}</b>: {obiekt.nazwa_obiektu}</>}
                />
                <Divider />
                <CardContent className={classes.cardContent}>
                    {
                        obiekt.systemy.length &&

                        <List className={classes.listRoot} dense>
                            {
                                obiekt.systemy.map(system => {
                                    return (
                                        <ListItem dense key={system.id_systemu}>
                                            <ListItemText
                                                primary={<small><b>{t('system.nazwa_systemu')}</b>: {system.nazwa_systemu}</small>}
                                                secondary={<small><b>{t('system.gestor')}</b>: {system.gestor}</small>}
                                                classes={{ primary: classes.primary }}
                                            />
                                        </ListItem>

                                    )
                                })
                            }
                        </List>
                    }

                    {/*<code style={{fontStyle: "italic"}}>{obiekt.systemy.length}</code>*/}
                    {/*<pre>{JSON.stringify(obiekt, null, 2)}</pre>*/}
                </CardContent>
            </Card>
        </div>
    );
}

export default ObjectCard
